import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import React from 'react';
import styled from 'styled-components';
import {
  ALLERGENS,
  DIETARY_LABELS,
  MULTIPLE_ALLERGENS,
} from '../../../constants';
import Checkbox from '../Checkbox';
import RaisedPanel from '../RaisedPanel';

const Section = styled.section`
  h2 {
    margin-top: 0 !important;
  }

  padding: 25px;
`;

const DietaryLabelsSection = styled(Section)`
  border-bottom: 1px solid #dedede;
`;

const AllergensSection = styled(Section)``;

const Header = styled.p`
  font-size: 15px;
  line-height: 16px;
  font-weight: 500;
  margin: 0px !important;
  letter-spacing: -0.2px;
`;

const Description = styled.p`
  font-size: 13px;
  line-height: 18px;
  color: #797979;
  letter-spacing: -0.2px;
  margin-top: 6px;
`;

const Checkboxes = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding-top: 2px;
`;

const checkedList = (items, index) =>
  items.map((item, i) => ({
    id: i,
    value: item,
    isChecked: index.has(item),
  }));

const HeaderContainer = styled.div`
  margin-top: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
  width: 100%;
`;

const GuidanceLink = styled.a`
  font-size: 11px;
  letter-spacing: -0.2px;
  float: right;
  clear: both;
  color: #797979;

  :hover {
    text-decoration: none;
  }
`;

function Allergens(props) {
  const {
    embedded,
    allergens,
    onAllergensSet,
    onAllergensChange,
    dietaryLabels,
    onDietaryLabelsChange,
  } = props;
  const allergensSet = new Set(allergens);
  const hasMultipleAllergens = allergensSet.has(MULTIPLE_ALLERGENS);
  const allergensList = checkedList(ALLERGENS, allergensSet).map(item => {
    item.disabled = hasMultipleAllergens && item.value !== MULTIPLE_ALLERGENS;
    return item;
  });

  const handleAllergensChange = (value, checked) => {
    if (value === MULTIPLE_ALLERGENS && checked) {
      onAllergensSet({ target: { value: [MULTIPLE_ALLERGENS] } });
    } else {
      onAllergensChange(value, checked);
    }
  };

  const dietaryLabelsList = checkedList(DIETARY_LABELS, new Set(dietaryLabels));
  const handleDietaryLabelsChange = (value, checked) =>
    onDietaryLabelsChange(value, checked);

  return (
    <RaisedPanel embedded={embedded} style={{ maxWidth: '720px' }}>
      <DietaryLabelsSection>
        <HeaderContainer>
          <Header>Dietary Labels</Header>
        </HeaderContainer>
        <Description>Select any labels that apply to this product.</Description>
        <Checkboxes>
          {dietaryLabelsList.map(d => (
            <Checkbox
              onSelect={handleDietaryLabelsChange}
              value={d.value}
              id={d.id}
              key={`dietary-check-${d.id}`}
              isChecked={d.isChecked}
            />
          ))}
        </Checkboxes>
      </DietaryLabelsSection>
      <AllergensSection>
        <HeaderContainer>
          <Header>Allergens</Header>
          <GuidanceLink
            href="https://www.food.gov.uk/business-guidance/allergen-guidance-for-food-businesses"
            target="_blank"
          >
            Allergens guidance
            <OpenInNewIcon
              style={{
                fontSize: 11,
                verticalAlign: 'bottom',
                marginLeft: '2px',
              }}
            />
          </GuidanceLink>
        </HeaderContainer>

        <Description>
          Select allergens that are contained in this product.
        </Description>
        <Checkboxes>
          {allergensList.map(s => (
            <Checkbox
              onSelect={handleAllergensChange}
              value={s.value}
              id={s.id}
              key={`allergen-check-${s.id}`}
              isChecked={s.isChecked}
              disabled={s.disabled}
            />
          ))}
        </Checkboxes>
      </AllergensSection>
    </RaisedPanel>
  );
}

export default Allergens;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/Allergens/allergens.jsx